module.exports = __webpack_public_path__ + "static/media/lease2_img12.7de679ff.jpg";